<script lang="ts">
	import CareerForm from "./CareerForm.svelte";
	import careerFormBgImage from "../assets/images/career-form-bg.jpeg?webp&w=1920&imagetools";
	import careerFormBgImageMobile from "../assets/images/career-form-bg-mobile.png?webp&w=428&imagetools";

	import StaticPicture from "./Picture/StaticPicture.svelte";
</script>

<section class="bg-tertiary relative py-16 lg:bg-transparent lg:py-32" id="careerForm">
	<StaticPicture
		image={careerFormBgImage}
		alt="Career form background"
		width={1920}
		height={1080}
		imgClass="absolute lg:bottom-0 lg:top-0 w-full h-full object-cover"
		class="absolute inset-0 -z-10 hidden md:block"
	/>
	<div class="container" id="career-form">
		<div class="lg:max-w-[75rem]">
			<CareerForm />
		</div>
	</div>

	<StaticPicture
		image={careerFormBgImageMobile}
		alt="Career form background"
		width={1920}
		height={1080}
		imgClass=""
		class="md:hidden"
	/>
</section>
